import { PlatformError } from "@components/platform-error/platform-error";
import { Button } from "@infinitaslearning/pixel-design-system";
import type { NextPageWithLayout } from "@pages/types";
import { type SupportedLocale, getOpCoWithLocale } from "@utils/get-opco-with-locale";
import Head from "next/head";
import { useRouter } from "next/router";
import { useConfig } from "src/config/hook";

const ERROR_MESSAGES = {
  nl: {
    title: "Oeps, er ging iets mis!",
    ctaText: "Startpagina",
    message: "404 - Deze pagina bestaat niet",
  },
  "nl-be": {
    title: "Oeps, er ging iets mis!",
    ctaText: "Startpagina",
    message: "404 - Deze pagina bestaat niet",
  },
  "fr-be": {
    title: "Erreur!",
    ctaText: "Accueil",
    message: "Nous avons informé nos développeurs.",
  },
  sv: {
    title: "Någonting är fel",
    ctaText: "Startsidan",
    message: "Vi meddelade våra utvecklare. Gå tillbaka till startsidan.",
  },
  en: {
    title: "Ooops, something went wrong",
    ctaText: "Home",
    message: "404 - this page doesn't exist",
  },
};

const HeadTitle: React.FC<{ locale: SupportedLocale }> = ({ locale }) => {
  return (
    <Head>
      <title>{ERROR_MESSAGES[locale || "en"].message}</title>
    </Head>
  );
};

const NotFound: NextPageWithLayout = () => {
  const router = useRouter();
  const config = useConfig();
  const { locale } = getOpCoWithLocale({ config });
  return (
    <>
      <HeadTitle locale={locale} />
      <PlatformError
        customTitle={ERROR_MESSAGES[locale || "en"].title}
        customMessage={ERROR_MESSAGES[locale || "en"].message}
        errorType="navigation"
        CustomCTA={
          <Button
            color="secondary"
            size="large"
            onClick={() => router.push("/")}
            variant="contained"
          >
            {ERROR_MESSAGES[locale || "en"].ctaText}
          </Button>
        }
      />
    </>
  );
};
export default NotFound;
